import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `comment?dossierId=${dossierId}`, method: 'GET', body: null, token: token })
}
